import Vue from 'vue';
import notifyError from '../../../../procedures/notify-error.js';
import notifySuccess from '../../../../procedures/notify-success.js';
import action from '../../../abstract/action.js';

export default action({
  label: 'Skopiuj link do faktury',
  icon: 'CopyIcon',
  handle: ({ $vs, item: { hash } }) => {
    if (hash === null) {
      notifyError({
        text: 'Faktura nie posiada aktywnego linku.',
      });

      return;
    }

    Vue.prototype.$copyText(import.meta.env.VITE_SITE_URL + '/print/invoice/' + hash)
      .then(() => {
          notifySuccess({
            $vs,
            text: 'Skopiowano link do faktury.',
          });
        },
      )
      .catch(() => {
        notifyError({
          $vs,
          text: 'Nie udało się skopiować linku. Odśwież stronę i spróbuj ponownie.',
        });
      });
  },
});
